import React from "react";
import "antd/dist/antd.css";
import Top from "../../../components/common/Top";
import Footer from "../../../components/common/Footer";
import Banner from "../common/Banner";
import { Layout } from "antd";
import ModuleContent from './ModuleContent'
import actionWays from "../../../redux/actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import "../../../inphone.scss";
import { adaptation } from "../../../utils/adaptation";
import "../common/index.scss";
const { Content } = Layout;
const bannerObj = {
  imgUrl: require("../../../assets/images/solution/common/banner3.png").default,
  name: "惠联档案一体化智能服务平台",
  title: "空间运营管理数智化",
  details: "科学、智能、安全的空间运营数智化解决方案",
};
class Guaranteed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicList: [],
      projectList: [],
      projectName: "",
    };
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation();
  }
  render() {
    const { t } = this.props;
    const electronicContent1 = t("spaceOperations.space_part2", {
      returnObjects: true,
    });
    const electronicContent2 = t("spaceOperations.space_part4", {
      returnObjects: true,
    });
    return (
      <Layout>
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          {/* 锚点 start*/}
          {/* <AnchorPoint anchorPointList={anchorPointList} /> */}
          {/* 锚点 end*/}
          {/* 模块内容 start */}
          <ModuleContent />
          {/* 模块内容 end */}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(Guaranteed)));
